/*
 * types/services/dr2am.tasks.permissions.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbPermissionRole} from './PbPermissionRole';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceUpdatePermissionResponse model module.
 * @module model/ServiceUpdatePermissionResponse
 * @version version not set
 */
export class ServiceUpdatePermissionResponse {
  /**
   * Constructs a new <code>ServiceUpdatePermissionResponse</code>.
   * @alias module:model/ServiceUpdatePermissionResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceUpdatePermissionResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceUpdatePermissionResponse} obj Optional instance to populate.
   * @return {module:model/ServiceUpdatePermissionResponse} The populated <code>ServiceUpdatePermissionResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceUpdatePermissionResponse();
      if (data.hasOwnProperty('permission'))
        obj.permission = PbPermissionRole.constructFromObject(data['permission']);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbPermissionRole} permission
 */
ServiceUpdatePermissionResponse.prototype.permission = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceUpdatePermissionResponse.prototype.state = undefined;


